<template>
  <section class="portables">
    <table class="w-full">
      <thead>
        <tr class="text-xl text-green font-bold bg-primary">
          <td class="p-2">Product Name</td>
          <td class="p-2 text-center">Qty.</td>
          <td class="p-2 text-center">Equivalized Qty.</td>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(item, index) in stats"
          :key="index"
          class="bg-light-grey"
        >
          <td v-html="item.title" class="border divide-primary p-2" />
          <td v-html="item.qty" class="border divide-primary p-2 align-top text-center" />
          <td v-html="equivalized(item)" class="border divide-primary p-2 align-top text-center" />
        </tr>
      </tbody>

      <tfoot>
        <tr class="text-xl text-green font-bold bg-primary">
          <td class="p-2 uppercase">Grand Total</td>
          <td v-html="totalQty" class="p-2 align-top text-center" />
          <td v-html="totalEquivalized" class="p-2 align-top text-center" />
        </tr>
      </tfoot>
    </table>
  </section>
</template>

<script>
export default {
  name: 'PortablesStats',
  props: {
    campaigns: Array,
    seasonals: Array,
    portables: Array,
    orderedItems: Array
  },
  data () {
    return {
      stats: []
    }
  },
  mounted () {
    this.statsParser();
  },
  computed: {
    totalQty () {
      let total = 0;
      this.stats.forEach(item => {
        total += item.qty;
      })

      return total;
    },
    totalEquivalized () {
      let total = 0;
      this.stats.forEach(item => {
        total += this.equivalized(item);
      })

      return total;
    }
  },
  methods: {
    statsParser () {
      let record = {
        title: "Portable Order",
        campaignId: 'Portable Order',
        items: [],
        totalQty: 0,
        totalEqQty: 0
      }

      this.orderedItems.forEach(orderedItem => {
        if (this.portables.find(p => p.id === parseInt(orderedItem.id)) && orderedItem.campaignId == 'Portable Order') {
          let item = record.items.find(statItem => statItem.id === parseInt(orderedItem.id))

          if (item) {
            item.qty += orderedItem.qty;
          } else {
            record.items.push({
              id: parseInt(orderedItem.id),
              title: orderedItem.title,
              equivalized: orderedItem.equivalized,
              qty: orderedItem.qty
            });
          }

          record.totalQty += orderedItem.qty;
          record.totalEqQty += this.equivalized(orderedItem);
        }
      })

      this.stats = record.items
    },
    equivalized (item) {
      return item.qty * (parseInt(item.equivalized) || 1);
    }
  }
}
</script>
